__webpack_require__.p = "https://ui.beta.eu-west-1.urc.advertising.amazon.dev/";